var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',{staticClass:"shadow flex justify-center py-2 px-4 mb-4",style:({ backgroundColor: ("" + (_vm.provider.hex_code)) })},[_c('img',{staticClass:"h-12",attrs:{"src":_vm.provider.icon_url,"alt":_vm.provider.name}})])}
var staticRenderFns = []

export { render, staticRenderFns }